import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  deviceByIdSelector,
  channelsSelector,
  deviceModelsSelector,
  devicesSelector,
  attachmentsByModelIdSelector,
} from '../selectors';
import {
  updateDeviceCommon,
  createAttachmentDevice,
  updateAttachment,
  deleteAttachment,
} from '../actions/entry';
import DeviceEditStep from '../components/DeviceModal/DeviceEditStep';

const makeMapStateToProps = (state, { id, onClose }) => {
  const device = deviceByIdSelector(state, id);
  const devices = devicesSelector(state);
  const channels = channelsSelector(state);
  const models = deviceModelsSelector(state);
  let attachments = [];
  attachments = attachmentsByModelIdSelector(state, id);

  return {
    devices,
    attachments,
    channels,
    models,
    device,
    onClose,
  };
};

const mapDispatchToProps = (dispatch, { id }) =>
  bindActionCreators(
    {
      onUpdate: (data) => updateDeviceCommon(id, data),
      onAttachmentCreate: (deviceId, data) => createAttachmentDevice(deviceId, data),
      onAttachmentUpdate: (data) => updateAttachment(data.id, data),
      onAttachmentDelete: deleteAttachment,
    },
    dispatch,
  );

export default connect(makeMapStateToProps, mapDispatchToProps)(DeviceEditStep);
